<template>
  <div class="remain_ticket_continer">
    <span class="left_tip size_34">今日免费门票剩余</span>
    <remainTicketNum></remainTicketNum>
    <!-- <div class="remain_continer">
      <span v-for="(item,index) in hourTicketsArr" class="remain_txt">{{item}}</span>
    </div> -->
    <span class="left_tip size_34">张</span>
  </div>
</template>

<script>

  import remainTicketNum from "@/components/remainTicketNum.vue";
  
  export default {
    name: "remainTicket",
    components: {
      remainTicketNum
    },
    props: {
      type: {
        default: 1
      },
     
    },
    data() {
      return {
        
      }
    },
    
  }
</script>

